import { PositionResult } from "common/position/dto/PositionResult";
import styled from "styled-components";
import PositionSingleNav from "components/common/position/PositionSingleNav";
import { Divider } from "@mui/material";
import NavLinkUndecorated from "components/common/style/link/NavLinkUndecorated";
import { positionLinkSingle } from "common/position/position_link_common";
import { dateFormatGet } from "common/date_common";
import { staticContentPath } from "common/static_content_common";
import PositionPlay from "components/common/position/PositionPlay";

type PositionItemProps = {
  position: PositionResult;
};

const PositionItem = ({ position }: PositionItemProps) => {
  return (
    <Div>
      <Divider />
      <Div>
        <NavLinkUndecorated to={positionLinkSingle(position.id)}>
          <div>{dateFormatGet(position.datum)}</div>
          <div>{position.title} </div>
          {position.fileName && (
            <PositionPlay
              filePath={staticContentPath(position.fileName)}
              autoPlay={false}
              muted={true}
              width={200}
            />
          )}
        </NavLinkUndecorated>
        <PositionSingleNav position={position} />
      </Div>
    </Div>
  );
};

const Div = styled.div`
  margin-top: 2rem;
`;

export default PositionItem;
